import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import MarketingLayout from '$components/MarketingLayout';
import MailchimpSignup from '$components/MailchimpSignup';
import Hero from '$components/Hero';
import { Flex, Col } from '$components/Flex';
import MarketingSection from '$components/MarketingSection';
import MarketingDivide from '$components/MarketingDivide';
import Contributions from '$components/MarketingContributions';
import Contribution from '$components/MarketingContribution';
import chat from '$images/contributions/chat2.png';
import code from '$images/contributions/code2.png';
import docs from '$images/contributions/docs.svg';
import sponsor from '$images/contributions/sponsor.png';
import stories from '$images/contributions/stories2.png';
import talks from '$images/contributions/talks3.png';
import write from '$images/contributions/write2.png';
export const _frontmatter = {
  "layout": "marketing",
  "path": "/contribute/",
  "title": "Contribute to PostGraphile"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <MarketingLayout blue mdxType="MarketingLayout">
      <Hero bg="white" mdxType="Hero">
        <h1>{`Contribute to Graphile projects`}</h1>
      </Hero>
      <MarketingSection bg="white" left maxWidth mdxType="MarketingSection">
        <h3>
  PostGraphile, Graphile Worker and the Graphile suite wouldn't be where they are today without valuable contributions from the open source community.
        </h3>
        <div className='flex'>
          <a className='button--solid' href='https://github.com/sponsors/benjie'>GitHub Sponsors<span className='fas fa-fw fa-external-link-square-alt' /></a>&nbsp;
          <a className='button--outline' href='https://github.com/graphile/'>Graphile on Github <span className='fas fa-fw fa-external-link-square-alt' /></a>
        </div>
      </MarketingSection>
      <MarketingDivide from="white" to="medium" mdxType="MarketingDivide" />
      <MarketingSection bg="medium" mdxType="MarketingSection">
        <h3>{`How to contribute`}</h3>
        <div style={{
          maxWidth: '48rem',
          margin: '0 auto'
        }}>
          <p>{`The Graphile suite wouldn`}{`'`}{`t be where it is today without the people who supported it by dedicating their time, skills and knowledge to it since its inception in 2016.`}</p>
          <p>{`There is always something for anyone who wants to get involved; be it programming, writing, presenting at meetups or more. We are working hard to build an inclusive and supportive community around the Graphile suite, and would love for more interested people to join.`}</p>
        </div>
      </MarketingSection>
      <MarketingDivide from="medium" to="dark" via="light" down mdxType="MarketingDivide" />
      <MarketingSection bg="dark" left mdxType="MarketingSection">
        <Contributions mdxType="Contributions">
          <Contribution title="Chat" icon={chat} mdxType="Contribution">
            <p>{`Join us on our `}<a parentName="p" {...{
                "href": "https://discord.gg/graphile"
              }}>{`chat server`}</a>{`. Here we discuss current plans for the project, and help users with queries. We always welcome more members who can help answer questions and share their experiences.`}</p>
          </Contribution>
          <Contribution title="Code" icon={code} mdxType="Contribution">
            <p>{`An easy way to get started with code contributions is to share code examples in our `}<a parentName="p" {...{
                "href": "/postgraphile/introduction/"
              }}>{`Documentation`}</a>{`, or write and share your own PostGraphile plugins. Come and discuss your ideas in the #plugin-development channel on our `}<a parentName="p" {...{
                "href": "https://discord.gg/graphile"
              }}>{`chat server`}</a>{`.`}</p>
          </Contribution>
          <Contribution title="Docs" icon={docs} mdxType="Contribution">
            <p>{`Adding to the documentation is always a valuable way to contribute. You can add code samples, explanations, images, example plugins, or anything else you think will be helpful. This will help you learn, and will teach other users too. Look for issues tagged `}<a parentName="p" {...{
                "href": "https://github.com/graphile/postgraphile/issues?utf8=%E2%9C%93&q=is%3Aissue+label%3A%22%F0%9F%93%84+add-to-docs%22+"
              }}>{`'Add to Docs'`}</a>{` as a way to start.`}</p>
          </Contribution>
          <Contribution title="Talks" icon={talks} mdxType="Contribution">
            <p>{`Talk about PostGraphile, Graphile Worker or one of the other tools at your local meetups and in your workplace. If you're planning on giving a presentation, let us know and we'll send you some stickers or `}<a parentName="p" {...{
                "href": "https://learn.graphile.org"
              }}>{`cheatsheets`}</a>{` to support your talk. You can contact us on our `}<a parentName="p" {...{
                "href": "https://discord.gg/graphile"
              }}>{`chat server`}</a>{` or `}<a parentName="p" {...{
                "href": "https://twitter.com/graphilehq"
              }}>{`on twitter`}</a>{` and we'll do what we can to help you.`}</p>
          </Contribution>
          <Contribution title="Stories" icon={stories} mdxType="Contribution">
            <p>{`We love to hear about your use of PostGraphile, whether a good experience or bad. Sharing your story helps us improve, and encourages other potential users to give our projects a try. We want to compile some user case studies, so please get in contact `}<a parentName="p" {...{
                "href": "https://discord.gg/graphile"
              }}>{`on chat`}</a>{` or `}<a parentName="p" {...{
                "href": "https://twitter.com/graphilehq"
              }}>{`on twitter`}</a>{` with your story.`}</p>
          </Contribution>
          <Contribution title="Write" icon={write} mdxType="Contribution">
            <p>{`Write and share your experiences with the project - it could be about how you use the project, what success you've seen, or anything else; sharing your experiences with PostGraphile, Graphile Worker or the other tools helps more people find us, which in turn allows the project to grow and become more sustainable. Don't forget to send us the link and we'll share your writing too.`}</p>
          </Contribution>
          <Contribution title="Sponsor" icon={sponsor} mdxType="Contribution">
            <p>{`Crowd-sourced funding enables us to spend the most time directly working on improving the Graphile suite, which you and other users then benefit from. Sponsorship money is used to fund software development, testing, documentation and releases of the PostGraphile and the Graphile software suite. `}<a parentName="p" {...{
                "href": "https://github.com/sponsors/benjie"
              }}>{`Sponsor on GitHub Sponsors here.`}</a></p>
          </Contribution>
        </Contributions>
      </MarketingSection>
      <MarketingDivide from="dark" to="medium" via="light" mdxType="MarketingDivide" />
      <MarketingSection bg="medium" left maxWidth mdxType="MarketingSection">
        <h3>{`Core Code Contribution Guide`}</h3>
        <p>{`We welcome code contributions, together we can make great software that enables developers to build powerful applications in record time. Your first step should be to check in with our maintainers on the `}<a parentName="p" {...{
            "href": "https://discord.gg/graphile"
          }}>{`Discord chat server`}</a>{` to see what areas of PostGraphile are being worked on at the moment. `}</p>
        <p>{`We also have a `}<a parentName="p" {...{
            "href": "https://github.com/graphile/postgraphile/blob/master/CONTRIBUTING.md"
          }}>{`Contributing Guide`}</a>{` which contains details of our development and testing environment as well as guidelines on commit messages and other things which are useful for code contributors. Be sure to read it through before making your pull request!`}</p>
        <p>{`Pull requests should be focussed to changing only one thing at a time, the smaller the PR the easier it is to review and the faster the turn-around time. Any large changes should seek maintainer approval first.`}</p>
      </MarketingSection>
      <MarketingDivide from="medium" to="dark" via="light" down mdxType="MarketingDivide" />
      <MarketingSection bg="dark" left maxWidth mdxType="MarketingSection">
        <h3>{`Code of Conduct`}</h3>
        <p>{`The Graphile projects are governed by the Contributor Covenant code of
conduct. In the interest of fostering an open and welcoming environment, we
as contributors and maintainers pledge to making participation in our project
and our community a harassment-free experience for everyone. This covers all
areas of the Graphile community, including: the source code, commit messages,
issues and pull requests on GitHub, any and all documentation, online chat
and official social media accounts. `}<a parentName="p" {...{
            "href": "/postgraphile/code-of-conduct/"
          }}>{`The full code of conduct can be found
here`}</a>{`.`}</p>
      </MarketingSection>
    </MarketingLayout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      